// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Text__Jsx3 = require("../../../../uikit/reason/helpers/Text__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var ReactErrorBoundary = require("react-error-boundary");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var UnselectedUnionMemberError = require("../../../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
var DuplicateQuietPropertyError = require("./DuplicateQuietPropertyError.bs.js");
var PropertyAddressValidationCallout = require("./PropertyAddressValidationCallout.bs.js");
var DuplicateBroadcastRentalPropertyError = require("./DuplicateBroadcastRentalPropertyError.bs.js");
var DuplicateBroadcastForSalePropertyError = require("./DuplicateBroadcastForSalePropertyError.bs.js");
var PropertyAddressValidationDuplicatePropertyError_property_graphql = require("../../../../__generated__/PropertyAddressValidationDuplicatePropertyError_property_graphql.bs.js");

var convertFragment = PropertyAddressValidationDuplicatePropertyError_property_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyAddressValidationDuplicatePropertyError_property_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyAddressValidationDuplicatePropertyError_property_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyAddressValidationDuplicatePropertyError_property_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyAddressValidationDuplicatePropertyError_property_graphql.node, convertFragment, fRef);
}

var Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyAddressValidationDuplicatePropertyError$PropertyAddressValidationDuplicatePropertyError$WithoutErrorBoundary(props) {
  var property = use(props.property);
  switch (property.__typename) {
    case "EditableBroadcastForSaleProperty" :
        return JsxRuntime.jsx(DuplicateBroadcastForSalePropertyError.make, {
                    property: property.fragmentRefs
                  });
    case "EditableBroadcastRentalProperty" :
        return JsxRuntime.jsx(DuplicateBroadcastRentalPropertyError.make, {
                    property: property.fragmentRefs
                  });
    case "EditableQuietProperty" :
        return JsxRuntime.jsx(DuplicateQuietPropertyError.make, {
                    property: property.fragmentRefs
                  });
    case "__unselected" :
        return UnselectedUnionMemberError.raise("Unselected editable property: " + property._0);
    
  }
}

var WithoutErrorBoundary = {
  make: PropertyAddressValidationDuplicatePropertyError$PropertyAddressValidationDuplicatePropertyError$WithoutErrorBoundary
};

var PropertyAddressValidationDuplicatePropertyError = {
  WithoutErrorBoundary: WithoutErrorBoundary
};

function PropertyAddressValidationDuplicatePropertyError$ErrorComponent(props) {
  return JsxRuntime.jsx(PropertyAddressValidationCallout.make, {
              heading: "There was an error validating the address",
              children: JsxRuntime.jsx(Text__Jsx3.make, {
                    lineHeight: {
                      NAME: "float",
                      VAL: 1.50
                    },
                    children: JsxRuntime.jsx("p", {
                          children: "We encountered and error while validating the address. Please try re-entering the address above"
                        })
                  }),
              icon: "Error"
            });
}

var ErrorComponent = {
  make: PropertyAddressValidationDuplicatePropertyError$ErrorComponent
};

function PropertyAddressValidationDuplicatePropertyError$1(props) {
  return JsxRuntime.jsx(ReactErrorBoundary.ErrorBoundary, {
              FallbackComponent: (function (_error) {
                  return JsxRuntime.jsx(PropertyAddressValidationDuplicatePropertyError$ErrorComponent, {});
                }),
              children: JsxRuntime.jsx(PropertyAddressValidationDuplicatePropertyError$PropertyAddressValidationDuplicatePropertyError$WithoutErrorBoundary, {
                    property: props.property
                  })
            });
}

var make = PropertyAddressValidationDuplicatePropertyError$1;

exports.Fragment = Fragment;
exports.PropertyAddressValidationDuplicatePropertyError = PropertyAddressValidationDuplicatePropertyError;
exports.ErrorComponent = ErrorComponent;
exports.make = make;
/* Text__Jsx3 Not a pure module */
